import { render, staticRenderFns } from "./SlotsDisplay.vue?vue&type=template&id=5b910826&scoped=true"
import script from "./SlotsDisplay.vue?vue&type=script&lang=js"
export * from "./SlotsDisplay.vue?vue&type=script&lang=js"
import style0 from "./SlotsDisplay.vue?vue&type=style&index=0&id=5b910826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b910826",
  null
  
)

export default component.exports